/**
 *
 * NoResults
 *
 */
import { Content, Heading, IllustratedMessage } from '@adobe/react-spectrum';
import React, { memo } from 'react';
import NotFound from '@spectrum-icons/illustrations/NotFound';
import './index.scss';
interface Props {
  message?: string;
  content?: string;
  size?: string;
}

export const NoResults = memo(({ message, content, size }: Props) => {
  return (
    <div
      className={size ? 'not-found-small' : 'not-found'}
      data-testid="no-results-container"
    >
      <IllustratedMessage data-testid="no-results-illustrated-message">
        <NotFound />
        <Heading data-testid="no-results-heading">
          {message ? message : 'No results'}
        </Heading>
        {content && (
          <Content data-testid="no-results-content">{content}</Content>
        )}
      </IllustratedMessage>
    </div>
  );
});
